import React, { useState } from 'react';

const ResearchPrompt = ({ concept }) => {
  const [prompt, setPrompt] = useState('');
  const [isCopied, setIsCopied] = useState(false);

  const generatePrompt = () => {
    const generatedPrompt = `
🧠 Deep Research Prompt: Deconstructing the Conceptual Blend — "${concept}"

Title: “The Emergent Architecture of Meaning: A Multi-Lens Inquiry into the Conceptual Blend of '${concept}'”

🧑‍🎓 Role: You are a Cognitive Linguist and Semantic Analyst specializing in conceptual blending theory and the deep structures of meaning. Your audience includes academics in linguistics, AI researchers, and creative strategists. Adopt a tone of rigorous intellectual exploration combined with creative insight.

🎯 Objective: Conduct a deep, lens-structured investigation into the novel concept of "${concept}". Deconstruct its constituent parts, analyze its emergent properties, and explore its potential applications and implications across various domains.

🔍 LENS-BASED FRAMEWORK FOR DEEP DIVE:

1. Etymological & Semantic Lens:
   - Trace the historical and semantic roots of the core words that make up "${concept}".
   - Identify the core conceptual dualities and tensions within each word (e.g., passive vs. active, creation vs. destruction).

2. Conceptual Blending (Four-Space Model) Lens:
   - Identify the primary "Input Spaces" for the blend.
   - Define the "Generic Space" that allows the blend to feel coherent.
   - Describe the "Blended Space," detailing its unique logic and emergent structure that is not present in the inputs alone.

3. Metaphorical & Symbolic Lens:
   - What new metaphors, symbols, or archetypes does the concept of "${concept}" create?
   - How does it tap into or challenge existing cultural or psychological symbols?

4. Domain Application Lens:
   - Explore the practical application of "${concept}" in at least three different fields (e.g., technology, art, philosophy, business, science).
   - How could this concept solve a problem or offer a new perspective in each domain?

5. Ethical & Philosophical Implications Lens:
   - What are the potential positive or negative ethical consequences of applying this concept?
   - Does "${concept}" reveal a deeper truth about human cognition, creativity, or the nature of reality?

📌 Output Deliverables:
   - A detailed breakdown of the Four-Space Network Model for this specific blend.
   - A list of at least five novel "what-if" scenarios or research questions inspired by the concept.
   - A concluding synthesis on why this conceptual blend is powerful, useful, or significant.
    `;
    setPrompt(generatedPrompt.trim());
    setIsCopied(false); // Reset copied state when new prompt is generated
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(prompt);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000); // Reset after 2 seconds
  };

  return (
    <div className="research-prompt-container">
      <button onClick={generatePrompt} className="generate-prompt-button">
        Generate Research Prompt
      </button>
      {prompt && (
        <div className="prompt-display">
          <textarea readOnly value={prompt} />
          <button onClick={copyToClipboard} className="copy-prompt-button">
            {isCopied ? 'Copied!' : 'Copy Prompt'}
          </button>
        </div>
      )}
    </div>
  );
};

export default ResearchPrompt;